export default defineNuxtPlugin(async () => {
  const { $axios } = useNuxtApp();
  const getClientIP = async (): Promise<string> => {
    try {
      const res = await fetch("https://api64.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch (error: any) {
      return "0.0.0.0";
    }
  };

  const clientIP = await getClientIP();

  $axios.interceptors.request.use((config: any) => {
    config.headers = {
      ...config.headers,
      "X-Client-IP": clientIP,
    };
    return config;
  }, null);
});
